<input class="form-control" [(ngModel)]="filter.value" type="text" placeholder="{{ filter.filterTemplate.label | translate }}" (keyup.enter)="onEnter()"/>
